import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import useTable from "../../../components/useTable";
//UI
import { SearchInput, Textarea, Input } from "../../../ui/inputs/Input";
import { DangerButton, PrimaryButton } from "../../../ui/buttons/Button";

const headCells = [
  {
    id: "id",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "ID",
    textAlign: "center",
  },
  {
    id: "descripcion",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Descripción",
    textAlign: "center",
  },
  {
    id: "monto",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Monto",
    textAlign: "center",
  },
];
export default function ModalTasasConexos({ setShow, show }) {
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  return (
    <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">IMPUESTOS/TASAS CONEXOS</h3>
        <a
          type="button"
          className="fw-bold text-light fs-6"
          onClick={() => setShow(false)}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap">
        <div className="col-4 m-0 mb-2 p-0">
          <SearchInput label="Código:" />
        </div>
        <div className="col-3 m-0 ml-auto p-0 pl-2">
          <Input label = 'Fecha:' type = "date"/>
        </div>
        <div className="col-9 m-0 mb-2 p-0">
          <Input label="Nombre del Contribuyente:" />
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label="Cedula o Rif:" />
        </div>
        <div className="col-12 m-0 p-0">
          <Textarea label="Dirección:" style={{ height: 70 }} />
        </div>
        <fieldset className="col-12 m-0 p-2 border-azul rounded">
          <legend className="float-none w-auto m-0">Tasas Conexos</legend>
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr key={index}></tr>
                ))}
            </tbody>
          </TblContainer>
        </fieldset>
      </Modal.Body>
      <Modal.Footer className="d-flex gap-2">
        <div className="col-auto m-0 p-0">
          <PrimaryButton icon = 'fa-plus'>Incluir</PrimaryButton>
        </div>
        <div className="col-auto m-0 p-0">
          <DangerButton>Cancelar</DangerButton>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
